// REGISTRY: mapea el `type` declarado en la config a un componente real.
// Agregar un widget nuevo a la galería = una línea aquí + su componente.
// La config solo referencia strings, nunca importa componentes → desacoplado.
import KpiCard, { KpiPair } from './base/KpiCard';
import PriceLineChart from './base/PriceLineChart';
import MultiLineChart from './base/MultiLineChart';
import MatrixTable from './base/MatrixTable';
import EChartsWidget from './base/EChartsWidget';

const WIDGET_REGISTRY = {
  kpi: KpiCard,
  kpiPair: KpiPair,
  // Widgets chart.js originales (se conservan para no romper dashboards previos).
  lineChart: PriceLineChart,
  multiLineChart: MultiLineChart,
  matrix: MatrixTable,
  // Motor avanzado config-driven: una sola entrada cubre line/multiLine/heatmap/gauge
  // según render_config.chart, con escape hatch render_config.option (ECharts).
  echarts: EChartsWidget,
};

export function resolveWidget(type) {
  return WIDGET_REGISTRY[type] || null;
}

export default WIDGET_REGISTRY;
